var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLayoutCommon1X1 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 18,
  viewBox: "0 0 28 18",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 26,
  height: 15.6,
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  rx: 2,
  transform: "translate(1 1)"
})));
export { SvgLayoutCommon1X1 as ReactComponent };
export default __webpack_public_path__ + "assets/images/layout-common-1x1.svg";